// Clima score palette — single source of truth for JS (charts, range configs).
// Keep in sync with the CSS variables (--clima-*) defined in src/scss/main.scss.
// Bands 1 (best) → 6 (worst).
export const CLIMA_COLORS = {
  1: "#8bc7a2",
  2: "#b8dda0",
  3: "#e6f2bc",
  4: "#f9ebbc",
  5: "#f7b89b",
  6: "#e88f89",
};

export default CLIMA_COLORS;



// WEBPACK FOOTER //
// ./src/components/climan/climaColors.js